import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-appsettings',
  templateUrl: './appsettings.component.html',
  styleUrls: ['./appsettings.component.css']
})
export class AppsettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
